/**
 * DateRangePicker component for selecting start and end dates.
 */

import { Input } from '@/components/ui';

interface DateRangePickerProps {
  /** Start date value (YYYY-MM-DD format) */
  startDate: string | null;
  /** End date value (YYYY-MM-DD format) */
  endDate: string | null;
  /** Callback when start date changes */
  onStartChange: (date: string | null) => void;
  /** Callback when end date changes */
  onEndChange: (date: string | null) => void;
  /** Optional class name */
  className?: string;
}

/**
 * Date range picker using native date inputs.
 * Provides accessible date selection for filtering.
 */
export function DateRangePicker({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  className = '',
}: DateRangePickerProps) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Input
        type="date"
        value={startDate ?? ''}
        onChange={(e) => onStartChange(e.target.value || null)}
        aria-label="Start date"
        className="w-36"
      />
      <span className="text-sm text-slate-500">to</span>
      <Input
        type="date"
        value={endDate ?? ''}
        onChange={(e) => onEndChange(e.target.value || null)}
        aria-label="End date"
        className="w-36"
      />
    </div>
  );
}
